/*
*	Different layer satellite source needs different time slider
* 	Time slider is displayed dependent of WMS layer which is on top of map
* 	This class enables interval, which checking top layer of map
* 	Currently only Sentinel (groupe 1 - default) nad Landsat (groupe 2 - array parameter) are supported.
* 	"group" parameter is array of ids of Landsat layers. All other layers are default Sentinel.
*/

import Map from 'ol/Map';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import LayerGroup from 'ol/layer/Group';

export class LayerOrder{
	constructor(map,slider,group){
		this.map = map;
		this.slider = slider;
		this.group = group;
		this.previous = "";
		
		this.setListener();
	}
	
	setListener(){
		let that = this;
		let flag = false;
		window.setInterval(function(){
		  let list = that.map.getLayers().getArray();									
			for(let i = (list.length - 1); i--;){
				let state = list[i];
					  if(state instanceof LayerGroup){
						  let sublist = state.getLayers().getArray();
						  
						  for(let j = (sublist.length);j--;){
							  flag = that.layerVisibility(sublist[j],j);
							  if(flag){ break};
						  }
					  }else{
						  flag = that.layerVisibility(state,i);
					  }
					  
					  if(flag){ break};					  
			}
		}, 500);
	}
	
	/*
	*	Internal layer visibility method
	*/
	layerVisibility(state,i){
		let that = this;
		let values = state.values_;
		if(values.visible && !(state instanceof VectorLayer)){
							if(state.id){	
								let current = state.id;
								
								  if(that.group.includes(current) && !that.group.includes(that.previous)){
									  //that.slider.reload({layer:"LST_LANDSAT_FLOAT", MAXCC:90});
									  that.slider.reload({TYPENAMES: "DSS6", TYPENAME: "DSS6"});	//Landsat WFS
								  }else if(!that.group.includes(current) && that.group.includes(that.previous)){
									  //that.slider.reload();	//WMS
									  that.slider.reload({TYPENAMES: "DSS1"});	//Sentinel WFS
								  }
							 
								 that.previous = state.id;
								return true;
							}
		}else{
			return false;
		}
	}
	
	
	/*
	*	Method returns layer settings of Landsat layer if its on top of map
	*/ 
	getTopLayerSettings(){
		if(this.group.includes(this.previous)){
			//return {layer:"LST_LANDSAT_FLOAT", MAXCC:90};
			return {TYPENAMES: "DSS6"};
		}else{
			return null;
		}
	}
}